import dayjs from 'dayjs';
import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import { VoiceAirMetricDefinition } from '../voice-air-metrics.types';
import { getHydratedCallRecordsQueryOptions } from '../voice-air-handoff.queries';
import { getParsedErrorMessage } from 'redux/axios';
import { WEAVE_APP_URL } from 'apis/sso/sso-url-config';

export const routingForwardingActivityMetric: VoiceAirMetricDefinition = {
  id: 'routing_forwarding_activity',
  name: 'Routing / Forwarding Activity (Configuration-Quality)',
  isRequired: true,
  criteria: [
    {
      description:
        'Verify recent call volume and routing configuration for the AI Receptionist over the last 30 days.',
      whereToFix: {
        label: 'Call Routes',
        url: `${WEAVE_APP_URL}/home/dashboard#settings/phone/call-routes?type=call-routes`,
      },
      evaluate: async (ctx) => {
        try {
          const startTime = dayjs().subtract(30, 'day').startOf('day').toISOString();
          const endTime = dayjs().endOf('day').toISOString();

          const response = await ctx.queryClient.fetchQuery(
            getHydratedCallRecordsQueryOptions(ctx.locationId, startTime, endTime)
          );

          const records = response?.records || [];

          if (records.length >= 10) {
            return {
              status: ChecklistMetricStatus.PASSED,
              reason: 'air_routing_activity_healthy',
              message:
                'AI Receptionist has received 10 or more calls in the last 30 days. Routing is active.',
            };
          }

          if (records.length >= 5 && records.length < 10) {
            return {
              status: ChecklistMetricStatus.WARNING,
              reason: 'air_routing_activity_low',
              message:
                'AI Receptionist has received fewer than 10 calls in the last 30 days. Routing activity may be low — verify call route configuration and phone number assignments.',
            };
          }

          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'air_routing_activity_insufficient',
            message:
              'AI Receptionist has received fewer than 5 calls in the last 30 days. This suggests calls are not being routed to AIR. Check call route setup, phone number assignments, and office hours.',
          };
        } catch (err) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'api_request_failed',
            message:
              getParsedErrorMessage(err) ||
              'Failed to verify routing/forwarding activity.',
          };
        }
      },
    },
  ],
};
